import { render } from "./SearchItemBarcodeType.vue?vue&type=template&id=5393746b"
import script from "./SearchItemBarcodeType.vue?vue&type=script&lang=ts"
export * from "./SearchItemBarcodeType.vue?vue&type=script&lang=ts"
script.render = render

export default script